import type { FormControlLabelProps } from '@material-ui/core';
import { FormControlLabel } from '@material-ui/core';
import type { CheckboxProps } from '@material-ui/core/Checkbox';
import MaterialUiCheckBox from '@material-ui/core/Checkbox';
import type { Ref } from 'react';
import React, { forwardRef } from 'react';

import CheckedIcon from '../../../assets/checkbox-checked.svg';
import Icon from '../../../assets/checkbox.svg';

import styles from './Checkbox.scss';

interface Props extends CheckboxProps {
  className?: string;
  label?: string | FormControlLabelProps['label'];
  labelProps?: Omit<FormControlLabelProps, 'control' | 'label'>;
}

const iconSize = 16;

const Checkbox = forwardRef<Ref<HTMLInputElement>, Props>(
  ({ className, labelProps, label, id, name, ...rest }, ref) => (
    <FormControlLabel
      classes={{ root: styles.labelRoot, disabled: styles.labelDisabled, label: styles.label }}
      label={label}
      control={
        <MaterialUiCheckBox
          className={className}
          classes={{ root: styles.checkbox, checked: styles.checked }}
          icon={<Icon width={iconSize} height={iconSize} />}
          checkedIcon={<CheckedIcon width={iconSize} height={iconSize} />}
          ref={ref as never}
          id={id}
          name={name ?? id ?? ''}
          {...rest}
        />
      }
      {...labelProps}
    />
  )
);

export default Checkbox;
